<template>
  <div class="row align-items-center">
    <div class="col-6 col-lg-3">
      {{ log.start_time || '-' }}
    </div>
    <div class="col-6 col-lg-3">
      {{ log.end_time || '-' }}
    </div>
    <div class="col-6 col-lg-3">
      {{ log.duration || '-' }}
    </div>
    <div class="col-6 col-lg-3 d-flex align-items-center">
      <i class="indicator far fa-fw me-3" :class="indicatorClass"></i>
      {{ log.type }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    log: {
      required: true,
      type: Object
    }
  },

  data () {
    return {
      indicatorClasses: {
        Online: 'fa-check text-success',
        Offline: 'fa-wifi-slash text-warning',
      }
    }
  },

  computed: {
    indicatorClass () {
      return this.indicatorClasses[this.log.type] || ''
    }
  }
}
</script>
